import React from 'react';
import ReactLoading from 'react-loading';
import './Sloading.css'
 
const SLoader = ({ type, color, message }) => {
    console.log(message)
    return(
        <div className="sloadercontainer">
            <div className="sloadingBox">
                <ReactLoading type={'spin'} color={'white'} height={'50%'} width={'50%'} />
                <span id="Loadingtag">{message}</span>
            </div>
        </div>
    )
}
 
export default SLoader;